/* @flow */
export type EnvType = 'staging' | 'development' | 'production' | 'local';

export default {
  BUILD_ENV: (process.env.REACT_APP_ENV || 'local': EnvType),
  ONESIGNAL_APP_DEV_ID: '25305d6b-1994-4cda-8a4d-949db5ab52b9',
};

export const STUB_TOKEN = 'stubToken';
